"use client";

import ArrowUpRight16 from "@ui/icons/16x16/arrow-up-right-16.svg";
import { cn } from "@ui/lib/utils";
import { useTranslations } from "next-intl";
import { captureEvent } from "@/app/_analytics/analytics";
import { EventName } from "@mw/shared/analyticsEventNames";
import { env } from "@/env";

interface StudioCTAButtonProps {
  className?: string;
}

export function StudioCTAButton({ className }: StudioCTAButtonProps) {
  const t = useTranslations("ClientKeys.VideoToMusic");

  return (
    <a
      className={cn(
        "w-full rounded-full bg-gradient-to-r from-black to-black py-8 text-center text-sm",
        "transition-all duration-200 hover:scale-[1.02] hover:shadow-lg",
        className,
      )}
      href={`${env.NEXT_PUBLIC_SERVER_URL}/app/studio?create=video-to-music`}
      onClick={() => {
        captureEvent(EventName.marketing_website_video_to_music_studio_redirected, undefined, {
          transport: "sendBeacon",
        });
      }}
    >
      <span className='flex items-center justify-center gap-8 text-inverse'>
        <ArrowUpRight16 />
        {t("full_soundtrack_cta")}
      </span>
    </a>
  );
}
